import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paper' : {
      width: '500px',
    },
  },
  contentRoot: {
    width: '100%',
  },
  header:{
    position: 'relative',
  },
  iconContainer: {
    left: 0,
    position: 'absolute',
  },
  title: {
    marginLeft: theme.spacing(1),
  },
  formContainer: {
    marginTop: theme.spacing(3),
  },
  dialogActions: {
    justifyContent: 'center',
  }
}));
